module.exports = __webpack_public_path__ + "img/logo.585232e3.svg";